import script from "./TrackingPointsData.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrackingPointsData.vue?vue&type=script&lang=ts&setup=true"

import "./TrackingPointsData.vue?vue&type=style&index=0&id=64a8ff51&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a8ff51"]])

export default __exports__